var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('share-base',{staticClass:"c-share-link--line",attrs:{"href":("http://line.me/R/msg/text/?" + _vm.text + " " + _vm.urlOnShare)},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }